import config from "../config";

const base_url = config.base_url;
/*
  Asset types are stored as literal English strings (`asset_type`), and the
  label shown to the user is looked up from that string: "Real Estate" ->
  `DublicatedText.real_estate`. So the display text can be changed freely in the
  language files without touching a single stored value — which is how the
  renamed types ("Retirement Plan / Annuity" and friends) work.

  The replace is global: without it only the first space became an underscore,
  so any type with more than two words could never find its key and silently
  fell back to the raw English. Every existing type is one or two words, so this
  changes no current lookup.
*/
export const getAssetTypeTranslated = (value, content, dublicatedcontent) => {
  let result;

  return dublicatedcontent[value?.toLowerCase()?.replace(/ /g, "_")] || value;
  switch (value) {
    case "Bank Account":
      result = content?.TableFilterText4 || value;
      break;
    case "Crypto Wallet":
      result = content?.TableFilterText5 || value;
      break;
    case "Life Insurance":
      result = content?.TableFilterText6 || value;
      break;
    case "Investment Account":
      result = content?.TableFilterText7 || value;
      break;
    case "Company Shares":
      result = dublicatedcontent?.dublicatedText5 || value;
      break;
    case "NFT":
      result = value;
      break;
    case "Password Manager":
      result = content?.TableFilterText9 || value;
      break;
    case "Password":
      result = dublicatedcontent?.dublicatedText62 || value;
      break;
    case "Real Estate":
      result = dublicatedcontent?.dublicatedText4 || value;
      break;
    case "Retirement Plan":
      result = content?.TableFilterText12 || value;
      break;
    case "Physical Vault":
      result = content?.TableFilterText13 || value;
      break;
    case "Your Will":
      result = content?.TableFilterText14 || value;
      break;
    case "Other":
      result = content?.TableFilterText15 || value;
      break;
    default:
      break;
  }
  return result;
};

export const updateCustomerLanguage = (language) => {
  fetch(base_url + "user/language/update", {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    body: `language=${language}`,
    credentials: "include",
  });
};
